import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import ImagePanel from '../../common/image/ImagePanel';
import ProjectDetail from './ProjectDetail';
import ProjectItem from './ProjectItem';
import ProjectPanel from './ProjectPanel';
import { useImageCompressingContext } from '../../../../contexts/ImageCompressingContext';

function ProjectPage({ isActive }) {
  const { openCNGProjectDetail, navigationContext } = useNavigationContext();
  const [projectList, setProjectList] = useState([]);
  const { accountContext } = useAccountContext();
  const [projectDetail, setProjectDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageManagerIsOpen, setImageManagerIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(undefined);
  const [type, setType] = useState('');
  const { languageContext } = useLanguageContext();
  const { setImageCompressingContext } = useImageCompressingContext();

  useEffect(() => {
    if (navigationContext.acitveProjectId) {
      fetchProjectDetail();
    } else setProjectDetail(undefined);
  }, [navigationContext, languageContext]);

  useEffect(() => {
    fetchProjectList();
  }, [languageContext]);

  const fetchProjectList = async () => {
    await privateFetch(
      'GET',
      'chiennoir',
      `/cu/${accountContext.id}/project/?lang=${languageContext}`
    ).then((res) => {
      setProjectList(res);
    });
  };

  const fetchProjectDetail = async () => {
    await privateFetch(
      'GET',
      'chiennoir',
      `/cu/${accountContext.id}/project/${navigationContext.acitveProjectId}/?lang=${languageContext}`
    ).then((res) => {
      if (res) setProjectDetail(res);
    });
  };

  const createProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'chiennoir',
      `/cu/${accountContext.id}/project/`,
      'Le projet a bien été ajouté',
      JSON.stringify(projectForm)
    ).then((res) => {
      fetchProjectList();
      setPanelIsOpen(false);
      setLoading(false);
      openCNGProjectDetail(res);
    });
  };

  const updateProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'chiennoir',
      `/cu/${accountContext.id}/project/${projectDetail.id}/?lang=${languageContext}`,
      'Le projet a bien été modifié',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProject = async (project) => {
    await privateFetch(
      'DELETE',
      'chiennoir',
      `/cu/${accountContext.id}/project/${project.id}/`,
      'Le projet a bien été supprimé'
    ).then(() => {
      fetchProjectList();
      setProjectDetail(undefined);
    });
  };

  const handleDeleteImage = async (image) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/image/${image.id}/`,
      "L'image a bien été supprimée"
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();

      setSelectedImage(undefined);
    });
  };

  const uploadProjectImage = async (imageForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'chiennoir',
      `/cu/${accountContext.id}/project/${projectDetail.id}/image/?type=${type}`,
      "L'image a bien été enregistrée",
      imageForm,
      false,
      true
    ).then((res) => {
      fetchProjectList();
      fetchProjectDetail();
      setLoading(false);
      setImageManagerIsOpen(false);
      setType('');
      setImageCompressingContext({
        image: res,
        file: imageForm.get('file')
      });
    });
  };

  const handleClickProject = (project) => {
    openCNGProjectDetail(project);
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newProjectAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un projet',
    icon: 'pi-plus'
  };

  const goBackProjectAction = {
    onClick: handleClickProject,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const handleCreateImage = () => {
    setSelectedImage(undefined);
    setImageManagerIsOpen(true);
  };

  const itemTemplate = (project) => (
    <ProjectItem project={project} handleClickProject={() => handleClickProject(project)} />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Projets"
        labelAction={handleClickProject}
        action={projectDetail ? goBackProjectAction : newProjectAction}
        detail={projectDetail}>
        {!projectDetail ? (
          <DataView value={projectList} itemTemplate={itemTemplate} className="pb-20" />
        ) : (
          <ProjectDetail
            project={projectDetail}
            handleUpdateProject={handleOpenManager}
            handleCreateImage={handleCreateImage}
            handleDeleteImage={handleDeleteImage}
            handleDelete={handleDeleteProject}
            setType={setType}
          />
        )}
        <ProjectPanel
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          project={projectDetail}
          onCreate={createProject}
          onUpdate={updateProject}
          loading={loading}
        />
      </PageWrapper>
      <ImagePanel
        image={selectedImage}
        loading={loading}
        isOpen={imageManagerIsOpen}
        onClose={() => {
          setSelectedImage(null);
          setImageManagerIsOpen(false);
          setType('');
        }}
        onCreate={uploadProjectImage}
      />
    </div>
  );
}

export default ProjectPage;
